const pad = (n: number): string => String(n).padStart(2, '0');

export function formatUpdatedAt(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
}

// The viewer's calendar day as YYYY-MM-DD; isoToday() is the UTC day.
export function localIsoToday(now: Date = new Date()): string {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}
